import UserDetailContainer from './UserDetailContainer';
export default UserDetailContainer;
